<span #spanElement>
  <ng-content />
</span>
